import React, { Component } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import { Grid, Row, Col } from "react-bootstrap";
import Select from 'react-select';

import { CustomCard } from "../../components/Card/CustomCard";

import Consignacion from "./AdmisionAdminContent/Consignacion";
import ListAdmision from "./AdmisionAdminContent/ListAdmision";

class AdmisionAdmin extends Component {
    state = {
        valorOpcion: { value: 'consignacion', label: 'Consignación de Documentos' },
        valorOpcion: { value: 'listado_admision', label: 'Listado de Nuevo Ingreso' },
    }

    Selecciona = (link) => {
        switch (link) {
            case "/admision_admin/consignacion":
                return({ value: 'consignacion', label: 'Consignación de Documentos' })
            case "/admision_admin/listado_admision":
                return({ value: 'listado_admision', label: 'Listado de Nuevo Ingreso' })
            default:
                return({ value: 'entidades', label: 'Consignación de Documentos' })
        }
    }

    valorSelectOpciones = (valorOpcion) => {
        this.setState({
            valorOpcion
        },() => {
            this.props.history.push(`/admision_admin/${this.state.valorOpcion.value}`);
        });
    }

    valorOpcionesLabel = (link) => {
        switch (link) {
            case "/admision_admin/consignacion": return('Consignación de Documentos')
            case "/admision_admin/listado_admision": return('Listado de Nuevo Ingreso')
            default: return('Consignación de Documentos')
        }
    }

    contenido = () => {
        return (
            <Switch>
                <Route path="/admision_admin/consignacion" component={ () => <Consignacion/> } />
                <Route path="/admision_admin/listado_admision" component={ () => <ListAdmision estCuenta = {true}/> } />
                <Redirect to = "/admision_admin/consignacion" />
            </Switch>
        )
    }

    render() {
        const Opciones = [
            { value: 'consignacion', label: 'Consignación de Documentos' },
            { value: 'listado_admision', label: 'Listado de Nuevo Ingreso' },
        ];

        return (
            <div className="content">
                <Grid fluid>
                    <div className="custom-alert-info" style={{marginBottom:15, padding:5}}>
                        <Row>
                            <Col md={9}>
                                <div className="title" style={{fontSize:14, paddingTop: 10}}>
                                    Selecciona una Opción
                                </div>
                            </Col>
                            <Col md={3}>
                                <Select
                                    isSearchable ={true}
                                    value={this.Selecciona(this.props.history.location.pathname)}
                                    onChange={this.valorSelectOpciones}
                                    options={Opciones}
                                />
                            </Col>
                        </Row>
                    </div>
                    <Row>
                        <Col md={12}>
                            <CustomCard
                                title={`Opciones de ${this.valorOpcionesLabel(this.props.history.location.pathname)}`}
                                category=""
                                color="#a80012"
                                content={this.contenido()}
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}
 
export default AdmisionAdmin;


// WEBPACK FOOTER //
// ./src/views/AdmisionAdmin/AdmisionAdmin.jsx